import testMP3 from './assets/audio/test.mp3'

const assets = {
  img: {},
  audio: {
    testMP3
  },
  video: {
    permissions: {
      permissionsMP4: 'https://d1qt3q0di8y5ko.cloudfront.net/permissions.mp4',
      permissionsWebm: 'https://d1qt3q0di8y5ko.cloudfront.net/permissions.webm'
    }
  }
}

export default assets
